import i18next from 'i18next';
import Cookies from 'js-cookie'
import { navigate } from '../config/router.config'
import { portalCfg } from '../config';
import { dataUtil, usage_type } from '../services/wsclients/dataUtil';
const ACCESS_TOKEN = 'access_token';
const REFRESH_TOKEN = 'refresh_token';
const USER_PROFILE = 'USER_PROFILE';
const ADDCARD_INFO = 'addcard_info';
const AMOUNT_PAYMENT='amount_payment';
const PACKAGE_INFO = 'package_info';
const PACKAGE_SELECTED = 'package_selected';
const ADDRESS_HOME = 'address_home';
const ORDER_INFO = 'order_info';
const CONTACT_INFO = 'contact_info';
const PAYMENT_INFO = 'payment_info';
const DEVICE_INFO = "device_info";
const PAYMENT_LINK_INFO = 'payment_link_info';
const REGISTER_ATTACHMENTS = 'register_attachments';
const UTM_INFO = 'utm_info';
const PROVIDER_ORDER = 'provider_order';
const TOPUP_MONTHLY_VIA_PAYMENTLINK = 'topup_monthly_via_paymentlink';
// var addressHome = {};
// var packageSelected = {};
var _getNotificationHandler = undefined;
export async function logOut() {
    clearSession();
    // navigate('/')
    window.location.href = `${window.location.origin}/`
}
export function saveTokenToCookie(key, value) {
    Cookies.set(key, value, { secure: true });
}
export function getTokenFromCookie(key) {
    let session = key ? Cookies.get(key) : Cookies.get(ACCESS_TOKEN);
    if (session)
        session = JSON.parse(session);
    return session;
}
export function saveDataIntoAsyncStore(key, data) {
    if (key === ACCESS_TOKEN || key === REFRESH_TOKEN) {
        Cookies.set(key, data, { secure: false});
    } else {
        localStorage.setItem(key, data);
    }
}
export function getData(key) {
    let session = null;
    if (key) {
        if (key === ACCESS_TOKEN || key === REFRESH_TOKEN) {
            session = Cookies.get(key);
        } else {
            session = localStorage.getItem(key);
        }
    } else {
        session = Cookies.get(ACCESS_TOKEN);
    }
    return session;
}

export function clearSession(key) {
    if (key)
        localStorage.removeItem(key);
    else {
        Cookies.remove(ACCESS_TOKEN);
        Cookies.remove(REFRESH_TOKEN);
        Cookies.remove(USER_PROFILE);
        localStorage.removeItem(USER_PROFILE);
        localStorage.removeItem(ADDRESS_HOME);
        localStorage.removeItem(PACKAGE_INFO);
        localStorage.removeItem(PACKAGE_SELECTED);
        localStorage.removeItem(ORDER_INFO);
        localStorage.removeItem(CONTACT_INFO);
        localStorage.removeItem(AMOUNT_PAYMENT);
        localStorage.removeItem(PAYMENT_INFO);
        localStorage.removeItem('order_status');
        localStorage.removeItem(DEVICE_INFO);
        localStorage.removeItem(ADDCARD_INFO);
        localStorage.removeItem(PAYMENT_LINK_INFO);
        localStorage.removeItem(REGISTER_ATTACHMENTS);
    }
}

export function clearOrderCache(key) {
    if (key)
        localStorage.removeItem(key);
    else {
        localStorage.removeItem(ADDRESS_HOME);
        localStorage.removeItem(PACKAGE_INFO);
        localStorage.removeItem(PACKAGE_SELECTED);
        localStorage.removeItem(AMOUNT_PAYMENT);
        localStorage.removeItem(PAYMENT_INFO);
        localStorage.removeItem(DEVICE_INFO);
        localStorage.removeItem(PAYMENT_LINK_INFO);
    }
}

export function setAppConfig(config){
    config = JSON.stringify(config)
    saveDataIntoAsyncStore('app_config',config);
}

export function getAppConfig(){
    let config = getData('app_config');
    //console.log('config====', config)
    if(config){
        config = JSON.parse(config);
    }
    return config;
}

export function setCurrency(currency){
    saveDataIntoAsyncStore('currency',currency);
}

export function getCurrency(){
    let currency = getData('currency');
    return currency;
}

export function setProfile(profile){
    profile = JSON.stringify(profile)
    saveDataIntoAsyncStore('profile',profile);
}

export function getProfile(){
    let profile = getData('profile');
    //console.log('profile====', profile)
    if(profile){
        profile = JSON.parse(profile);
    }
    return profile;
}

export function getDataChangeService(){
    let dataChangeService = getData('change_service');
    //console.log('dataChangeService====', dataChangeService)
    if(dataChangeService){
        dataChangeService = JSON.parse(dataChangeService);
    }
    return dataChangeService;
}

export function setDataChangeService(changeService){
    changeService = JSON.stringify(changeService)
    saveDataIntoAsyncStore('change_service',changeService);
}

export function setAddCardInfo(data){
    data = JSON.stringify(data)
    saveDataIntoAsyncStore(ADDCARD_INFO, data);
}

export function getAddCardInfo() {
    try{
        var value = localStorage.getItem(ADDCARD_INFO);
        if(value){
            value = JSON.parse(value);
        }
        return value;
    }
    catch(ex){
        console.log("get data to local storage for order exception:",ex);
        return null;
    }
}

export function setNotificationListener(callbackFn) {
    //console.log('HHHHHHHHH  setNotificationListener ' + key, callback);
    _getNotificationHandler = callbackFn;
}
export function callNotificationListeners() {
    try {
        _getNotificationHandler();
    }catch (e) {
        console.log(e);
    }
}

export function formatDateToDDMMYYYYFrEpoch(epochTime,normal) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return normal ? formatDateToDDMMYYYY(d) : formatDateToMonthNameAndDayOfWeek(d);;
}
export function formatDateToDDMMYYYY(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth() + 1;
    if (day < 10) day = '0' + day;
    if (month < 10) month = '0' + month;
    var dateFormatted = day + '/' + month + '/' + date.getFullYear();
    return dateFormatted;
}
export function formatDateToMonthNameAndDayOfWeek(date) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];

    return dayOfWeek + '. ' + formatDateToShortMonthName(date);
}
export function formatDateToShortMonthName(date) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear();
    return dateFormatted;
}
export function formatDateToDDMMYYYYHHSSFrEpoch(epochTime) {
    var d = new Date(epochTime * 1000); // The 0 there is the key, which sets the date to the epoch
    return formatDateTimeToMonthNameAndDayOfWeek(d);
}
export function formatDateTimeToMonthNameAndDayOfWeek(date) {
    var date = new Date(date);
    var dayOfWeeks = createShortDayOfWeek();
    var dayOfWeek = dayOfWeeks[date.getDay()];

    return dayOfWeek + '. ' + formatDateTimeToShortMonthName(date);
}

export function formatDateTimeToShortMonthName(date,withSecond) {
    var date = new Date(date);
    var day = date.getDate();
    var month = date.getMonth();
    if (day < 10) day = '0' + day;
    var months = createShortMonth();
    month = months[month];
    var hours = date.getHours()
    var minutes = date.getMinutes();
    var second = date.getSeconds();
    if (hours < 10) hours = '0' + hours;
    if (minutes < 10) minutes = '0' + minutes;
    if (second < 10) second = '0' + second;
    var time = hours + ":" + minutes 
    if(withSecond)
        time = time +  ":" + second;
    var dateFormatted = day + ' ' + month + ' ' + date.getFullYear() + " " + time;
    return dateFormatted;
}

export function createShortDayOfWeek() {

    var day =  i18next.t('SHORTDAYS',{ returnObjects: true});
    let days = [
        day.SUNDAY,
        day.MONDAY,
        day.TUESDAY,
        day.WEDNESDAY,
        day.THURSDAY,
        day.FRIDAY,
        day.SATURDAY,
    ];
    return days;
}

export function createShortMonth() {
    var month =  i18next.t('SHORTMONTH',{ returnObjects: true});
    let months = [
        month.JAN,
        month.FEB,
        month.MAR,
        month.APR,
        month.MAY,
        month.JUN,
        month.JUL,
        month.AUG,
        month.SEP,
        month.OCT,
        month.NOV,
        month.DEC,
    ];

    return months;
}

export function getLogo(){
    var logoUrl = "";
    if (portalCfg.localLogo) {
        var path = portalCfg.publicPath;
        logoUrl = path+ "/images/logo.png"
    } else {
        var app_config = getAppConfig();
        var srcset = ""
        
        if (app_config && app_config.creatives && app_config.creatives.length > 0) {
            var media = app_config.creatives[0].media;
            if (media && media.length > 0) {
                var srcset = ""
                media.forEach((element, index) => {
                    srcset = srcset + element.url + " " + (index + 1) + "x,";
                });
                if (srcset)
                    srcset = srcset.substr(0, srcset.length - 1);
            }
            let business_logo = dataUtil.getImageByUsageTypePortal(app_config.creatives, usage_type.APP_LOGO, true);
            if(business_logo){
                logoUrl = business_logo && business_logo.url ? business_logo.url : null;
            }else{
                var path = portalCfg.publicPath;
                logoUrl = path+ "/images/logo.png";
            }
        }
    }

    return logoUrl
}

export function setAddressHome(address){
    // addressHome = address;
    address = JSON.stringify(address)
    localStorage.setItem(ADDRESS_HOME, address);
}

export function getAddressHome(){
    // return addressHome;
    var config = localStorage.getItem(ADDRESS_HOME);
    if (!config)
        return null;
    config = JSON.parse(config);
    
    return config
}

export function setPackageInfo(package_info){
    // packageInfo = package_info;
    package_info = JSON.stringify(package_info)
    localStorage.setItem(PACKAGE_INFO, package_info);
}

export function getPackageInfo(){
    // return packageInfo;
    var config = localStorage.getItem(PACKAGE_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setPackageSeleted(package_info){
    // packageSelected = package_info;
    package_info = JSON.stringify(package_info)
    localStorage.setItem(PACKAGE_SELECTED, package_info);
}

export function getPackageSeleted(){
    // return packageSelected;
    var config = localStorage.getItem(PACKAGE_SELECTED);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setAmountPayment(data) {
    data = JSON.stringify(data)
    localStorage.setItem(AMOUNT_PAYMENT, data);
}

export function getAmountPayment() {
    var config = localStorage.getItem(AMOUNT_PAYMENT);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setOrderInfoCache(data) {
    data = JSON.stringify(data)
    localStorage.setItem(ORDER_INFO, data);
}

export function getOrderInfoCache() {
    var config = localStorage.getItem(ORDER_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setContactInfo(data) {
    data = JSON.stringify(data)
    localStorage.setItem(CONTACT_INFO, data);
}

export function getContactInfo() {
    var config = localStorage.getItem(CONTACT_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setPaymentInfo(data) {
    data = JSON.stringify(data)
    localStorage.setItem(PAYMENT_INFO, data);
}

export function getPaymentInfo() {
    var config = localStorage.getItem(PAYMENT_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setDeviceInfo(device_info){
    device_info = JSON.stringify(device_info)
    localStorage.setItem(DEVICE_INFO, device_info);
}

export function getDeviceInfo(){
    var config = localStorage.getItem(DEVICE_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setPaymentLinkInfo(data){
    data = JSON.stringify(data)
    localStorage.setItem(PAYMENT_LINK_INFO, data);
}

export function getPaymentLinkInfo(){
    var config = localStorage.getItem(PAYMENT_LINK_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setRegisterAttachments(data){
    data = JSON.stringify(data)
    localStorage.setItem(REGISTER_ATTACHMENTS, data);
}

export function getRegisterAttachments(){
    var config = localStorage.getItem(REGISTER_ATTACHMENTS);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setUTMInfo(data){
    data = JSON.stringify(data)
    localStorage.setItem(UTM_INFO, data);
}

export function getUTMInfo(){
    var config = localStorage.getItem(UTM_INFO);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setProviderOrder(data) {
    data = JSON.stringify(data)
    localStorage.setItem(PROVIDER_ORDER, data);
}

export function getProviderOrder() {
    var config = localStorage.getItem(PROVIDER_ORDER);
    if (!config)
        return null;
    config = JSON.parse(config);
    return config
}

export function setTopupMonthlyViaPaymentLink(isTopupPaymentlink){
    localStorage.setItem(TOPUP_MONTHLY_VIA_PAYMENTLINK, isTopupPaymentlink);
}


export function clearTopupMonthlyViaPaymentLink(){
    localStorage.removeItem(TOPUP_MONTHLY_VIA_PAYMENTLINK);
}

export function getTopupMonthlyViaPaymentLink(){
    var isTopupPaymentlink = localStorage.getItem(TOPUP_MONTHLY_VIA_PAYMENTLINK);
    if (isTopupPaymentlink){
        return true;
    }
    
    return false;
}

export function setPaymentMethod(data) {
    localStorage.setItem('payment_method', data);
}

export function getPaymentMethod() {
    var config = localStorage.getItem("payment_method");
    if (!config)
        return null;
    return config
}
